import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function Nav() {
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate()

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-gradient-to-b from-black/70 to-black/0"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
        {/* Logo */}
        <a
          onClick={() => navigate("/")}
          className="text-white font-bold tracking-widest text-3xl font-spartan hover:opacity-75 transition-opacity cursor-pointer"
        >
          SE7ENS
        </a>

        {/* Links */}
        <div className="flex gap-8 text-md font-medium">
          <a onClick={() => navigate("/about")} className="text-white hover:opacity-75 transition-opacity cursor-pointer">
            About
          </a>
        </div>
      </div>
    </nav>
  );
}

export default Nav;
